import type { AdminDeductionRow } from '@billda/api';
import type { DeductionGroup } from './groupDeductionsByWorker';
import { summariseDeductions } from './summariseDeductions';

/**
 * Groups deductions by siteName, sorted alphabetically.
 * "Unassigned" (null siteName) is always sorted last.
 */
export function groupDeductionsBySite(
  deductions: AdminDeductionRow[]
): DeductionGroup[] {
  const groupMap = new Map<string, AdminDeductionRow[]>();

  for (const deduction of deductions) {
    const name = deduction.siteName ?? 'Unassigned';
    const existing = groupMap.get(name);
    if (existing) {
      existing.push(deduction);
    } else {
      groupMap.set(name, [deduction]);
    }
  }

  return [...groupMap.entries()]
    .sort(([a], [b]) => {
      if (a === 'Unassigned') return 1;
      if (b === 'Unassigned') return -1;
      return a.localeCompare(b);
    })
    .map(([groupName, groupDeductions]) => {
      const summary = summariseDeductions(groupDeductions);
      return {
        groupName,
        deductions: groupDeductions,
        totalAmount: summary.totalAmount,
        count: summary.count,
      };
    });
}
